export default __webpack_public_path__ + "static/media/tinder.e20ffc47.svg";